<template>
  <div v-if="haveData" class="chart-wrapp" style="max-width: 100%;">
    <div class="weather-graph-buttons">
      <div class="weather-graph-buttons_wr">
        <p class="calendar-perido-error">{{dateError}}</p>
        <flat-pickr
          v-model="dateTime"
          :config="pickerConfig"
          class="form-control"
          placeholder="Выберите дату"
          name="date"></flat-pickr>
        <div @click="applyDate" :class="['statistics-select__button', loading ? 'loading' : '']">применить <i class="load-style"></i></div>
      </div>
    </div>

    <div class="weather-graph-start">
      <highcharts :key="componentKey" :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import 'flatpickr/dist/themes/dark.css'
import '@/assets/css/js-datapicer.scss'
import graphConfigs from '@/components/graphConfigs'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import station from '@/api/station'
import object from 'lodash'
import StatisticsHelper from '@/helpers/StatisticsHelper'

stockInit(Highcharts)

export default {
  name: 'PowerAndInsolation',
  mixins: [graphConfigs],
  components: {
    'highcharts': Chart,
    flatPickr
  },
  data () {
    return {
      haveData: true,
      componentKey: 0,
      dateTime: null,
      loading: false,
      dateFrom: moment()
        .subtract(2, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      dateTo: null,
      dateError: '',
      pickerConfig: {
        dateFormat: 'Y-m-d',
        mode: 'range',
        onChange: this.pickerChange
      },
      chartOptions: {
        chart: {
          alignTicks: false,
          marginLeft: 100
        },
        series: [
          {
            data: [],
            name: 'Total power'
          }
        ],
        xAxis: {
          labels: {
            style: {
              color: '#fff'
            }
          }
        },
        rangeSelector: {
          inputEnabled: false,
          buttons: [
            {
              type: 'all',
              text: 'Всё',
              dataGrouping: {
                forced: true,
                units: undefined
              }
            },
            {
              type: 'day',
              count: 1,
              text: 'Почасово',
              dataGrouping: {
                forced: true,
                units: [
                  [
                    'hour',
                    [1]
                  ]
                ]
              }
            }
          ],
          buttonTheme: {
            fill: '#333333',
            stroke: '#333333',
            width: 90,
            height: 17,
            style: {
              color: '#ffffff',
              fontSize: '14px'
            },
            states: {
              hover: {
                fill: '#242526',
                stroke: '#242526'
              },
              select: {
                fill: '#f36f37',
                stroke: '#f36f37'
              }
            }
          }
        },
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value} KW, KVA',
            style: {
              color: '#FFFFFF'
            }
          },
          gridLineColor: '#4f5051',
          title: {
            text: 'Apparent/Active power',
            style: {
              color: '#FFFFFF'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Reactive power',
            style: {
              color: '#FFFFFF'
            }
          },
          labels: {
            format: '{value} KVar',
            style: {
              color: '#FFFFFF'
            }
          },
          opposite: false
        }]
      }
    }
  },
  mounted () {
    if (this.$store.getters['station/station'].schema.insolationSensor !== null) {
      this.chartOptions.yAxis.push({ // Tertiary yAxis
        gridLineWidth: 0,
        title: {
          text: 'Insolation',
          style: {
            color: '#FFFFFF'
          }
        },
        labels: {
          format: '{value} W/m^2',
          style: {
            color: '#FFFFFF'
          }
        },
        opposite: true
      })
    }

    this.fetchData()
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    },
    fetchData () {
      this.loading = true

      station.powerAndInsolation(this.$route.params.id, {
        from: this.dateFrom,
        to: this.dateTo,
        each: StatisticsHelper.calculateBatch(this.dateFrom, this.dateTo)
      }).then(r => {
        const series = []

        series.push({
          data: r.data.p,
          name: 'Active power'
        })
        series.push({
          data: r.data.q,
          name: 'Reactive power',
          yAxis: 1
        })
        series.push({
          data: r.data.s,
          name: 'Apparent power'
        })

        if (r.data.hasOwnProperty('lines')) {
          object.forOwn(r.data.lines, (values, key) => {
            const device = this.$store.getters['station/devices'].find(device => device.id === Number(key))

            series.push({
              data: values,
              name: device.name
            })
          })
        }

        if (r.data.hasOwnProperty('insolationPlane')) {
          series.push({
            data: r.data.insolationPlane,
            name: 'Insolation plane',
            yAxis: 2
          })
        }
        if (r.data.hasOwnProperty('insolationHorizon')) {
          series.push({
            data: r.data.insolationHorizon,
            name: 'Insolation horizontal',
            yAxis: 2
          })
        }

        this.chartOptions.series = series
        this.componentKey++
        this.loading = false
      })
    },
    applyDate () {
      const diff = moment(this.dateTo)
        .diff(moment(this.dateFrom), 'days')

      if (diff > 31) {
        this.dateError = 'Период не больше месяца'
      } else {
        clearInterval(this.polling)
        this.fetchData()
        this.dateError = ''
      }
    },
    pickerChange (selectedDates, dateStr, instance) {
      const date = dateStr.replace('to', '#')
      instance.element.value = date
      const result = date.match(/(\d{4}-\d{2}-\d{2})\s#\s(\d{4}-\d{2}-\d{2})/)

      if (result !== null) {
        this.dateFrom = `${result[ 1 ]} 00:00:00`
        this.dateTo = `${result[ 2 ]} 00:00:00`
      }
    }
  }
}
</script>
